import utilsApi from "../../api/utils"

// general state for the eCommerce
const state = {
  photos: [],
  fetched: false,
  error: false,
  dataShape: [],
  extraInfo: {},
}

const getters = {
  photos: state => state.photos,
  photos_fetched: state => state.fetched,
  photosError: state => state.error,
  photos_dataShape: state => state.dataShape,
  photos_extraInfo: state => state.extraInfo,
}

const actions = {
  async SET_LISTING_PHOTO({ commit }, id) {
    let apiResponse = await utilsApi.setListingPhoto(id)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      return true
    } else {
      commit("PHOTOS_ERROR")
      return false
    }
  },
  async DELETE_photos({ commit }, id) {
    let apiResponse = await utilsApi.deletePhoto(id)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      return true
    } else {
      commit("PHOTOS_ERROR")
      return false
    }
  },
  async CREATE_photos({ commit }, photo) {
    let apiResponse = await utilsApi.createObject("photos", photo)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PHOTOS_SETTING", apiResponse)
    } else {
      commit("PHOTOS_ERROR")
    }
  },
  async SAVE_photos({ commit }, photo) {
    let apiResponse = await utilsApi.saveObject("photos", photo)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PHOTOS_SETTING", apiResponse)
      return true
    } else {
      commit("PHOTOS_ERROR")
      return false
    }
  },
  async FETCH_photos({ commit }) {
    let apiResponse = await utilsApi.getObjects("photos")
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PHOTOS_SETTING", apiResponse)
      return true
    } else {
      commit("PHOTOS_ERROR")
      return false
    }
  },
}
const mutations = {
  PHOTOS_SETTING: (state, { photos, dataShape, extraInfo }) => {
    console.log(state)
    state.photos = photos
    state.dataShape = dataShape
    state.extraInfo = extraInfo
    state.fetched = true
    state.error = false
  },
  PHOTOS_ERROR: state => {
    state.photos = null
    state.fetched = true
    state.error = false
    state.dataShape = []
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
